<div class="hidden-xs hidden-sm text-center"
     *ngIf="page && page.totalPages>1">
  <ct-pagination [boundaryLinks]="true"
                 [pageIndex]="page.pageIndex"
                 [maxSize]="10"
                 [disable]="!enable"
                 [totalItems]="page.totalItems"
                 [pageSize]="page.pageSize"
                 [displayEllipsesWhenNotShowingAllPageNumbers]="true"
                 [queryParams]="queryParams">
  </ct-pagination>
</div>
<div class="hidden-lg hidden-md text-center"
     *ngIf="page && page.totalPages>1">
  <ct-pagination [boundaryLinks]="false"
                 [pageIndex]="page.pageIndex"
                 [maxSize]="5"
                 [disable]="!enable"
                 [totalItems]="page.totalItems"
                 [pageSize]="page.pageSize"
                 [queryParams]="queryParams">
  </ct-pagination>
</div>